































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Confirmation extends Vue {
  dialog = false;

  get message(): string {
    return this.$store.state.confirmation.message;
  }

  get isVisible(): string {
    return this.$store.state.confirmation.isVisible;
  }

  set isVisible(val: string) {
    !val ? this.$store.dispatch('HIDE_CONFIRMATION') : this.$store.dispatch('SHOW_CONFIRMATION');
  }

  confirm() {
    this.$store.dispatch(this.$store.state.confirmation.action, this.$store.state.confirmation.payload);
    this.$store.dispatch('HIDE_CONFIRMATION');
  }

  cancel() {
    this.$store.dispatch('HIDE_CONFIRMATION');
  }


  mounted() {
    this.bindKeys();
  }

  beforeDestroy() {
    this.unBindKeys();
  }

  bindKeys() {
    window.addEventListener('keyup', this.onKeyUp);
  }

  unBindKeys() {
    window.removeEventListener('keyup', this.onKeyUp);
  }

  onKeyUp(event: KeyboardEvent) {
    if (['Enter', 'NumpadEnter'].indexOf(event.code) > -1) this.isVisible && this.confirm();
    if (event.code === 'Escape') this.isVisible && this.cancel();
  }
}
